module.exports = __webpack_public_path__ + "static/media/07-open.724c90dd.png";